import React from 'react';
import { ElementsCollection } from "./shaders/ElementsCollection";
import "./shaders/threeui.css";

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Engineering from './components/Engineering';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div style={{ position: 'relative', minHeight: '100vh', background: '#080f17', overflowX: 'hidden', width: '100%' }}>
      <div className="shader-frame" style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
        <ElementsCollection
          variant="condensation"
          speed={1.00}
          dropAmount={1.00}
          opacity={1.00}
        />
      </div>
      <div style={{ position: 'relative', zIndex: 1 }}>
        <Navbar />
        <main>
          <Hero />
          <About />
          <Skills />
          <Engineering />
          <Projects />
          <Experience />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;

